module.exports = __webpack_public_path__ + "04_medium_grey.d8bd5d65.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer5/04_medium_grey.png
// module id = IJb9
// module chunks = 0